module.exports = __webpack_public_path__ + "img/ep-M-dosis.844d5cd7.jpg";